import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useUpdateSuccessDialogStyles = makeStyles({
  surface: {
    maxWidth: '420px',
    width: '90vw',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  successIcon: {
    color: tokens.colorPaletteGreenForeground1,
    fontSize: fontScale.subheading,
  },
  bodyText: {
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
    margin: '0',
  },
});
